import React from 'react';
import { styled, css } from "styled-components";

const Btn = styled.button`
  border: 0px;
  background: red;
  height: 38px;
  padding: 6px 20px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #9738FF;
  
  color: #FFF;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;

  &:disabled {
    background: #ccc;
    color: #999;
    cursor: not-allowed;
  }
  
  ${p => p.type == 'secondary'
    ? css`
        text-align: right;
        background-color: #F3ECFF;
        color: #9738FF;
        margin-left: 5px;
        margin-right: 5px;
      `
    : css``
  }
`;

const Button = ({title, ...props}) => {
  return <Btn {...props}>{title}</Btn>;
};

export default Button;
